import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { onePageCheckoutDispositionDecisionStyles } from "@dana/Widgets/OnePageCheckout/OnePageCheckoutDispositionDecision";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

onePageCheckoutDispositionDecisionStyles.container = mergeToNew(onePageCheckoutDispositionDecisionStyles.container, {
    gap: 0,
    css: css`
        background: ${themeBackgrounds.white};
    `,
});

onePageCheckoutDispositionDecisionStyles.headingContainer = mergeToNew(
    onePageCheckoutDispositionDecisionStyles.headingContainer,
    {
        gap: 0,
        css: css`
            background: ${themeBackgrounds.lightGray};
            padding: 16px;
        `,
    },
);

onePageCheckoutDispositionDecisionStyles.titleText = mergeToNew(onePageCheckoutDispositionDecisionStyles.titleText, {
    size: fontSizes.medium,
    lineHeight: lineHeights.medium,
    css: css`
        margin-bottom: 0;
        letter-spacing: normal;
    `,
});

onePageCheckoutDispositionDecisionStyles.fulfillmentMethodGridItem = mergeToNew(
    onePageCheckoutDispositionDecisionStyles.fulfillmentMethodGridItem,
    {
        css: css`
            padding: 16px;
        `,
    },
);

onePageCheckoutDispositionDecisionStyles.servicesGridContainer = mergeToNew(
    onePageCheckoutDispositionDecisionStyles.servicesGridContainer,
    {
        gap: 10,
    },
);

onePageCheckoutDispositionDecisionStyles.servicesGridItem = mergeToNew(
    onePageCheckoutDispositionDecisionStyles.servicesGridItem,
    {
        width: [12, 6, 4, 4, 4],
        css: css`
            &.carrier-service {
                flex-direction: column;
                gap: 4px;
            }
        `,
    },
);
